import React, { useState, useRef } from 'react'
import { t } from '@/utils/i18n'
import { common, utils, uploadCommonEt } from '@/utils'
import ProductShare from '@/pages/Album/components/Share/ProductShare'
import useDisableBodyScroll from '@/hooks/useDisableBodyScroll'
import styles from './index.module.less'

interface DetailBarProps {
  productName: string
  mediaList: string[]
  video: string
}

const { getUuid } = utils

const DetailBar: React.FC<DetailBarProps> = (props) => {
  const { mediaList, video, productName } = props

  const [shareVisible, setShareVisible] = useState(false)
  const cartBtn = useRef<HTMLButtonElement>(null)
  useDisableBodyScroll(shareVisible)

  // 分享链接
  function onShare() {
    setShareVisible(true)
  }

  // 下载所有主图的图片和视频
  const onDownloadAllImgs = (e: any) => {
    // 7.8.3需求埋点：进入商品详情页后，点击【下载所有图片】按钮
    uploadCommonEt(17)

    // 阻止事件冒泡
    e.stopPropagation()
    // 获取货品的图片和视频
    let files: { url: string; type: 'image' | 'video'; name: string }[] =
      mediaList.map((url: string) => ({
        url,
        type: 'image',
        name: getUuid() + '.jpg',
      }))
    files = video
      ? files.concat({ url: video, type: 'video', name: getUuid() + '.mp4' })
      : files
    console.log('mediaList', mediaList)
    console.log('files', files)
    common.downloadFiles(files)
  }

  return (
    <div className={styles['detail-bar']}>
      <div className={styles['detail-bar-bd']}>
        <div className={styles['btn-wrap']}>
          <button ref={cartBtn} onClick={onShare}>
            {t('分享')}
          </button>
        </div>
        <div className={styles['btn-wrap']}>
          <button
            className={styles['download-btn']}
            ref={cartBtn}
            onClick={onDownloadAllImgs}
          >
            {t('下载所有图片')}
          </button>
        </div>
      </div>

      {shareVisible && (
        <ProductShare
          productName={productName}
          image={mediaList[0]}
          onClose={() => {
            setShareVisible(false)
          }}
        />
      )}
    </div>
  )
}

export default DetailBar
